var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"margin-left":"-45px","magin-right":"-45px"}},[_c('iframe',{staticStyle:{"width":"900px","height":"100vh"},attrs:{"src":_vm.origin() + _vm.url()}}),_c('Spinner',{attrs:{"loading":_vm.tf}}),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }